// node:crypto is not available, and this is being migrated very soon, so this is a temporary quick solution
export default async function getSHA256Hash(input) {
  const textAsBuffer = new TextEncoder().encode(input);
  const hashBuffer = await window.crypto.subtle.digest('SHA-256', textAsBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hash = hashArray.map(item => item.toString(16).padStart(2, '0')).join('');
  return hash;
}
